import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@emotion/react";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import { elevatedRow } from "./cardStyle";

const LotterySelector = ({ entries, selectedKey, onSelect }) => {
  const theme = useTheme();

  if (!entries?.length) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        gap: 1.5,
        overflowX: "auto",
        pb: 1,
        mb: 1.5,
        "&::-webkit-scrollbar": { height: 6 },
        "&::-webkit-scrollbar-thumb": { background: "#ffffff22", borderRadius: 3 },
      }}
    >
      {entries.map((entry) => {
        const isSel = entry?.key === selectedKey;
        return (
          <Box
            key={entry?.key}
            onClick={() => onSelect(entry?.key)}
            sx={{
              cursor: "pointer",
              flexShrink: 0,
              // Sizes to the name now that the prize figure is gone, so long
              // lottery names fit and short ones leave no dead space.
              width: "auto",
              maxWidth: 320,
              borderRadius: "14px",
              px: 2,
              py: 1.1,
              border: isSel
                ? `1.5px solid ${theme.palette.custom.green01}`
                : "1px solid #ffffff1e",
              background: isSel
                ? "linear-gradient(135deg, #0d2b16 0%, #123c1f 100%)"
                : "#ffffff08",
              boxShadow: isSel
                ? `0 8px 20px rgba(3,179,73,0.3), ${elevatedRow.boxShadow}`
                : elevatedRow.boxShadow,
              transition: "all .18s",
              "&:hover": { border: `1px solid ${theme.palette.custom.green01}88` },
            }}
          >
            <Typography
              sx={{
                fontSize: "14px",
                color: isSel ? theme.palette.custom.green01 : "#ffffffcc",
                textTransform: "uppercase",
                letterSpacing: 0.8,
                fontWeight: 800,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              <ConfirmationNumberIcon sx={{ fontSize: 16, mr: 0.6, verticalAlign: "-3px" }} />
              {entry?.name}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default LotterySelector;
